export default __webpack_public_path__ + "static/media/StarIconGreen.8f13136d.svg";